import React from 'react';
import PropTypes from 'prop-types';

import { useStyles } from '../checkoutDrawer.styles';

function AddOnsSummary ({ addOns, formatPriceUnit }) {
    const classes = useStyles();

    if (!addOns || addOns.length === 0) {
        return null;
    }

    return (
        <ul className={classes.addOnsSummaryList} aria-label="Selected add-ons">
            {addOns.map((addOn) => (
                <li key={addOn.id} className={classes.addOnSummaryRow}>
                    <div className={classes.addOnSummaryContent}>
                        <span className={classes.addOnSummaryName}>
                            {addOn.name}
                            {addOn.quantity > 0 && ` x ${addOn.quantity}`}
                            <span className={addOn.recurring ? classes.badgeRecurring : classes.badgeOneTime}>
                                {addOn.recurring ? 'Monthly' : 'One-time'}
                            </span>
                        </span>
                        <span className={classes.addOnSummaryPrice}>{formatPriceUnit(addOn.priceValue)}</span>
                    </div>
                </li>
            ))}
        </ul>
    );
}

AddOnsSummary.propTypes = {
    addOns: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        recurring: PropTypes.bool,
        priceValue: PropTypes.number,
        quantity: PropTypes.number,
    })),
    formatPriceUnit: PropTypes.func.isRequired,
};

AddOnsSummary.defaultProps = {
    addOns: [],
};

export default AddOnsSummary;
